import { lazy } from 'react'
import type { RouteConfig } from '~/utils/routing'

const Layout = lazy(() => import('./layout'))

const route: RouteConfig<Record<string, never>> = {
	path: '/account/action',
	exact: false,
	component: Layout,
}

export default route
